module.exports = __webpack_public_path__ + "static/media/DEFENSE-AND-WAR-ZONE-CARGO-MOVEMENTS.6f24be7d.jpg";